import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useContext,
} from "react";
import Footer from './Common_Components/Footer';
import Card from 'react-bootstrap/Card';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import axios from 'axios';
import { ProductContext } from "../context/AppContext";

const LifeInJapan = () => {


  const [activePage, setActivePage] = useState("Learning");
  const location = useLocation();
  const navigate = useNavigate();
  const LifeJapan = location.state;
  const quizTypeId = LifeJapan?.quiz_id;
  const quizName = LifeJapan?.quiz_name;
  console.log("Quiz id and Quiz Name :", quizTypeId, quizName);
  // const [skit, setSkits] = useState([]);
  const { skit } = useContext(ProductContext);
  console.log("skit :", skit);
  // const [isLoading, setIsLoading] = useState(true);
  const authToken = localStorage.getItem("AuthToken");
  const [isLoading, setIsLoading] = useState(true);
  const { Translate } = useContext(ProductContext);
  if (isLoading) {

  }
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  return (
    <div className='LifeInJapan   d-flex flex-column' style={{ minHeight: "100vh" }} >
      <div className='header_inner' >
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={() => navigate('/Learn')} className='icon_1' />
              <h2>{quizName}</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>


      <div className="lifeInJapan" style={{ marginTop: "100px", marginBottom: "100px" }}>
        <div className="lifeInjapan_heading">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h3>{Translate?.message?.data?.ChooseTheProfessionYouWantToLearnAboutInJapan || "Choose the Profession you want to learn about in Japan"}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="row">
              {skit.map((skitData, index) => {
                // State to track image loading status

                return (
                  <div
                    className="col-6 col-sm-6 col-md-3 mb-3 d-flex justify-content-center"
                    key={index}
                  >
                    <Card
                      className="lifeInJapan_card h-100"
                      onClick={() =>
                        navigate("/JapanHSchool", {
                          state: {
                            categoryId: skitData.category_id,
                            skitName: skitData.name_english,
                          },
                        })
                      }
                    >

                      <Card.Img
                        variant="top"
                        src={isLoading ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : skitData.url} // Show dummy image while loading
                        alt={skitData.name_english}
                        onLoad={() => setIsLoading(false)}
                        onError={() => setIsLoading(false)}
                        style={{
                          objectFit: "cover",
                          height: "200px",
                        }}
                      />

                      <Card.Body>
                        <h6>{skitData.name_japnese}</h6>
                        <Card.Text>{skitData.name_english}</Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                );
              })}

            </div>
          </div>
        </div>
      </div>
      {/* <Footer/> */}
            <Footer />
    </div>

  )
}

export default LifeInJapan
